<template>
  <div class="page">
    
    <div class="page-content">
      <img src="http://aisinuocdn.qupinmall.com/FkSwCNBKk9jjH98wtW9dBhGKNRoM" alt="">
      <el-card>
        <el-button
          style="margin: 10px 20px 0"
          @click="$router.go(-1)"
          type="success"
          size="mini"
          >返回上一页</el-button
        >
        <div class="form-area">
          <div class="form-row">
            <div class="column-meal-type">
              <div class="set-padding">
                <el-date-picker :disabled="formStatus!==1" type="date" placeholder="选择日期" v-model="date">
              </el-date-picker>
              </div>
              
            </div>
            <div class="column-meal-noon row-col-center">午餐</div>
            <div class="column-meal-supper row-col-center">晚餐</div>
          </div>
          <template v-for="(item,index) in cform">
            <div class="form-row" :key="item.meal_type">
              <div class="column-meal-type row-col-center">
                {{ item.meal_type }}
              </div>
              <div class="column-meal-noon row-col-center">
                <div class="set-padding">
                  <div class="edit-cai">
                    <span>A餐:</span>

                    <div @click="imgPickClick(index,'AMA')" class="img-select-box">
                      <input @change="(e)=>imgInputChange(e,index,true,true)" :id="'imgInputAMA' + index" :ref="'imgInput' + index" v-show="false" type="file" name="">
                      <img v-if="!item.lunch.a.pic" class="default-img" src="@/assets/default-img.png" alt="">
                      <img v-else class="default-img" :src="item.lunch.a.pic" alt="">
                    </div>
                    
                    <div class="cai-input-box">
                      <div class="set-margin">
                        <span>简称:</span>
                        <el-input
                          v-model="item.lunch.a.simple"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                      <div>
                        <span>菜式: </span>
                        <el-input
                          v-model="item.lunch.a.full"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="edit-cai">
                    <span>B餐:</span>
                    <div @click="imgPickClick(index,'AMB')" class="img-select-box">
                      <input @change="(e)=>imgInputChange(e,index,true,false)" :id="'imgInputAMB' + index" :ref="'imgInput' + index" v-show="false" type="file" name="">
                      <img v-if="!item.lunch.b.pic" class="default-img" src="@/assets/default-img.png" alt="">
                      <img v-else class="default-img" :src="item.lunch.b.pic" alt="">
                    </div>
                    <div class="cai-input-box">
                      <div class="set-margin">
                        <span>简称: </span>
                        <el-input
                          v-model="item.lunch.b.simple"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                      <div>
                        <span>菜式: </span>
                        <el-input
                          v-model="item.lunch.b.full"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column-meal-supper row-col-center">
                <div class="set-padding">
                  <div class="edit-cai">
                    <span>A餐:</span>
                    <div @click="imgPickClick(index,'PMA')" class="img-select-box">
                      <input @change="(e)=>imgInputChange(e,index,false,true)" :id="'imgInputPMA' + index" :ref="'imgInput' + index" v-show="false" type="file" name="">
                      <img v-if="!item.dinner.a.pic" class="default-img" src="@/assets/default-img.png" alt="">
                      <img v-else class="default-img" :src="item.dinner.a.pic" alt="">
                    </div>
                    <div class="cai-input-box">
                      <div class="set-margin">
                        <span>简称: </span>
                        <el-input
                          v-model="item.dinner.a.simple"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                      <div>
                        <span>菜式: </span>
                        <el-input
                          v-model="item.dinner.a.full"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="edit-cai">
                    <span>B餐:</span>
                    <div @click="imgPickClick(index,'PMB')" class="img-select-box">
                      <input @change="(e)=>imgInputChange(e,index,false,false)" :id="'imgInputPMB' + index" :ref="'imgInput' + index" v-show="false" type="file" name="">
                      <img v-if="!item.dinner.b.pic" class="default-img" src="@/assets/default-img.png" alt="">
                      <img v-else class="default-img" :src="item.dinner.b.pic" alt="">
                    </div>
                    <div class="cai-input-box">
                      <div class="set-margin">
                        <span class="set-margin">简称: </span>
                        <el-input
                          v-model="item.dinner.b.simple"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                      <div>
                        <span>菜式: </span>
                        <el-input
                          v-model="item.dinner.b.full"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          
          <div class="post-form-btn">
            <el-button v-loading.fullscreen.lock="fullscreenLoading" @click="formStatus===1?onSubmit(0):onSubmit(1)">
              {{formStatus===1?'提交':'修改'}}
            </el-button>
          </div>
          

        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import * as qiniu from "../../apis/qiniu";
import axios from 'axios'
export default {
  data() {
    return {
      formStatus: 1, // 1是新增 2是更新
      date: null,
      lunchOrDinnerDemo: {
        a: {
          pic: null,
          simple: '',
          full: '',
        },
        b: {
          pic: null,
          simple: '',
          full: '',
        },
      },
      singleMealDemo: {
        pic: null,
          simple: '',
          full: '',
      },
      mealTypeList: ['普通餐','行政餐','幼儿餐','学生餐','活动餐'],
      cform: [
        {
          meal_type: '普通餐',
          lunch: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
          dinner: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
        },
        {
          meal_type: '行政餐',
          lunch: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
          dinner: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
        },
        {
          meal_type: '幼儿餐',
          lunch: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
          dinner: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
        },
        {
          meal_type: '学生餐',
          lunch: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
          dinner: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
        },
        {
          meal_type: '活动餐',
          lunch: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
          dinner: {
            a: {
              pic: null,
              simple: '',
              full: '',
            },
            b: {
              pic: null,
              simple: '',
              full: '',
            },
          },
        },
      ],
      
      fullscreenLoading: false,
      apiUrlList: ['/api/meal/add','/api/meal/update']
    }
  },
  methods: {
    base64ToBlob(base64Data) {
      let arr = base64Data.split(","),
        fileType = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        l = bstr.length,
        u8Arr = new Uint8Array(l);

      while (l--) {
        u8Arr[l] = bstr.charCodeAt(l);
      }
      return new Blob([u8Arr], {
        type: fileType,
      });
    },
    // blob转file
    blobToFile(newBlob, fileName) {
      newBlob.lastModifiedDate = new Date();
      newBlob.name = fileName;
      return newBlob;
    },
    async qiniuUpload(data) {
      var res = await this.$http.get("/api/qiniu/gettoken");
      res = res.data;
      var blob = this.base64ToBlob(data);
      var file = this.blobToFile(blob);
      if (res.status == '200') {
        let param = new FormData(); //创建form对象
        param.append('file',file);//通过append向form对象添加数据
        param.append('token',res.data.token);//通过append向form对象添加数据
        let config = {
          headers:{'Content-Type':'multipart/form-data'}
        }; //添加请求头
        var response = await axios.post('https://upload-z2.qiniup.com',param,config);
        return res.data.url + response.data.key;
      }else {
        return '';
      }
      
    },
    imgPickClick(index,t) {
      // AMA AMB PMA PMB
      var tempRef = `imgInput${t}${index}`;
      document.getElementById(tempRef).click();
    },
    imgInputChange(e,index,isAm,isAmeal) {
      var _this = this;
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);    //Base64
      fileReader.onload = function() {
        if (isAm) {
          if (isAmeal) {
            _this.cform[index].lunch.a.pic = fileReader.result;
          }else {
            _this.cform[index].lunch.b.pic = fileReader.result;
          }
        }else {
          if (isAmeal) {
            _this.cform[index].dinner.a.pic = fileReader.result;
          }else {
            _this.cform[index].dinner.b.pic = fileReader.result;
          }
          
        }
      };
    },
    checkNeedUpload(pic) {
      if (pic.indexOf("http") === 0 || pic.length == 0) {
        return false;
      }else {
        return true;
      }
    },
    async tranformForm() {
      var tempForm = JSON.parse(JSON.stringify(this.cform));
      for (let index = 0; index < tempForm.length; index++) {
        var meal = tempForm[index];
        if (meal.lunch.a.pic != null && this.checkNeedUpload(meal.lunch.a.pic)) {
          tempForm[index].lunch.a.pic = await this.qiniuUpload(meal.lunch.a.pic);
        }
        if (meal.lunch.b.pic != null && this.checkNeedUpload(meal.lunch.b.pic)) {
          tempForm[index].lunch.b.pic = await this.qiniuUpload(meal.lunch.b.pic);
        }
        if (meal.dinner.a.pic != null && this.checkNeedUpload(meal.dinner.a.pic)) {
          tempForm[index].dinner.a.pic = await this.qiniuUpload(meal.dinner.a.pic);
        }
        if (meal.dinner.b.pic != null && this.checkNeedUpload(meal.dinner.b.pic)) {
          tempForm[index].dinner.b.pic = await this.qiniuUpload(meal.dinner.b.pic);
        }
      }
      return tempForm;
    },
    processForm(tempForm) {
      var _this = this;
      const cDate = new Date(this.date);
      const list = [];
      var isReturnNull = false;
      tempForm.forEach((item) => {
        const mealType = this.judgeMealType(item.meal_type)
        for (const outkey in item) {
          if (outkey !== 'meal_type') {
            for (const innerKey in item[outkey]) {
              var {pic,simple,full} = item[outkey][innerKey];
              if (!pic && !simple && !full) {
                continue;
              }
              var temp1 = !pic ? 0 : 1;
              var temp2 = !simple ? 0 : 2;
              var temp3 = !full ? 0 : 4;
              var tempJudge = temp1+temp2+temp3;
              if (tempJudge < 7 && tempJudge > 0) {
                _this.$message.error('请填写完整信息');
                isReturnNull = true;
                return null;
              }
              list.push({
                pic: item[outkey][innerKey].pic,
                simple: item[outkey][innerKey].simple,
                full: item[outkey][innerKey].full,
                type: innerKey === 'a' ? 1 : 2,
                meal_type: mealType,
                date:
                  cDate.getFullYear() +
                  '-' +
                  (cDate.getMonth() + 1) +
                  '-' +
                  cDate.getDate(),
                period: outkey === 'lunch' ? 1 : 2,
                id: item[outkey][innerKey].id,
              })
            }
          }
        }
      })
      if (isReturnNull) {
        return null;
      }
      if (list.length == 0) {
        this.$message.error('数据不能为空');
        return null;
      }
      return list;
    },
    processAddOrUpdateResult(res) {
      if (res.status == 200) {
        this.$message({
          message: res.msg || '操作成功',
          type: 'success',
        });
        this.$router.go(-1);
      } else {
        this.$message.error(res.msg || '操作失败');
      }
    },
    async onSubmit(apiIndex) {
      this.fullscreenLoading = true;
      var tempForm = await this.tranformForm();
      const list = this.processForm(tempForm);
      if (!list) return this.fullscreenLoading = false;
      this.$http.post(this.apiUrlList[apiIndex], { list: list }).then((res) => {
        this.processAddOrUpdateResult(res.data);
        this.fullscreenLoading = false;
      }).catch(err=>this.fullscreenLoading = false);
    },
    judgeMealType(meal_type) {
      let type
      switch (meal_type) {
        case '普通餐':
          type = 1
          break
        case '行政餐':
          type = 2
          break
        case '幼儿餐':
          type = 3
          break
        case '学生餐':
          type = 4
          break
        case '活动餐':
          type = 5
          break
      }
      return type
    },
    formatterData(data) {
      const caiItem = []
      data.forEach((eat) => {
        const periodType = this.judgePeriod(eat.period)
        const type = this.judgeType(eat.type)
        const mealType = this.judgeMealTypeToString(eat.meal_type)
        const index = this.judgeArrayHasCai(mealType, caiItem)
        if (index !== -1) {
          if (
            !Object.prototype.hasOwnProperty.call(caiItem[index], periodType)
          ) {
            caiItem[index][periodType] = {}
          }
          caiItem[index][periodType][type] = {
            pic: eat.pic,
            full: eat.full,
            simple: eat.simple,
          }
        } else {
          const cai = { meal_type: mealType }
          cai[periodType] = {}
          cai[periodType][type] = {
            pic: eat.pic,
            full: eat.full,
            simple: eat.simple,
          }
          caiItem.push(cai)
        }
      })
      return caiItem
    },
    formatterDataToUpdate(data) {
      var caiItem = []
      data.forEach((eat) => {
        const periodType = this.judgePeriod(eat.period)
        const type = this.judgeType(eat.type)
        const mealType = this.judgeMealTypeToString(eat.meal_type)
        const index = this.judgeArrayHasCai(mealType, caiItem)
        if (index !== -1) {
          if (
            !Object.prototype.hasOwnProperty.call(caiItem[index], periodType)
          ) {
            caiItem[index][periodType] = {}
          }
          caiItem[index][periodType][type] = {
            pic: eat.pic,
            full: eat.full,
            simple: eat.simple,
            id: eat.id,
          }
        } else {
          const cai = { meal_type: mealType }
          cai[periodType] = {}
          cai[periodType][type] = {
            pic: eat.pic,
            full: eat.full,
            simple: eat.simple,
            id: eat.id,
          }
          caiItem.push(cai)
        }
      })
      for (let index = 0; index < caiItem.length; index++) {
        if (!caiItem[index].lunch) {
          caiItem[index]['lunch'] = this.lunchOrDinnerDemo;
        }
        if (!caiItem[index].dinner) {
          caiItem[index]['dinner'] = this.lunchOrDinnerDemo;
        }
        if (!caiItem[index].lunch.a) {
          caiItem[index].lunch['a'] = this.singleMealDemo;
        }
        if (!caiItem[index].lunch.b) {
          caiItem[index].lunch['b'] = this.singleMealDemo;
        }
        if (!caiItem[index].dinner.a) {
          caiItem[index].dinner['a'] = this.singleMealDemo;
        }
        if (!caiItem[index].dinner.b) {
          caiItem[index].dinner['b'] = this.singleMealDemo;
        }
      }
      if (caiItem.length < this.mealTypeList.length) {
        var tempres = [];
        var insertIndexList = [];
        caiItem.forEach(item => {
          var tempIndex = this.mealTypeList.findIndex(t => t == item.meal_type);
          insertIndexList.push(tempIndex);
        })
        for (let index = 0; index < this.mealTypeList.length; index++) {
          if (insertIndexList.indexOf(index) != -1) {
            tempres.push(caiItem[insertIndexList.indexOf(index)]);
          }else {
            tempres.push(this.cform[index]);
          }
        }
        caiItem = tempres;
      }

      return caiItem
    },
    judgeMealTypeToString(mealType) {
      let type
      switch (mealType) {
        case 1:
          type = '普通餐'
          break
        case 2:
          type = '行政餐'
          break
        case 3:
          type = '幼儿餐'
          break
        case 4:
          type = '学生餐'
          break
        case 5:
          type = '活动餐'
          break
      }
      return type
    },
    judgePeriod(period) {
      return period === 1 ? 'lunch' : 'dinner'
    },
    judgeType(type) {
      return type === 1 ? 'a' : 'b'
    },
    judgeArrayHasCai(meal_type, array) {
      let index = -1
      for (var i = 0; i < array.length; i++) {
        if (array[i].meal_type === meal_type) {
          index = i
        }
      }
      return index
    },
    setPic(data) {
      const caiItem = this.cform.filter(
        (item) => item.meal_type === data.meal_type
      )[0]
      const locat = data.location.split('.')
      caiItem[locat[0]][locat[1]].pic = data.pic
    },
  },
  created() {
    this.date = new Date()
    if (this.$route.params.date) {
      this.date = this.$route.params.date;
      this.formStatus = 2
      this.$http
        .get('/api/meal/view', { params: { date: this.date } })
        .then((res) => {
          this.$nextTick(() => {
            this.cform = this.formatterDataToUpdate(res.data.data)
          })
        })
    }
  },
}
</script>

<style scoped>
.set-margin {
  margin: 12px 0;
}
.img-select-box {
  width: 100px;
  height: 100px;
  margin: 12px 12px;
  position: relative;
}
.default-img {
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 6px;
}
.page {
  margin: 30px;
}
.el-row {
  border-bottom: 1.5px solid #f2f2f2;
  padding: 10px;
}
.edit-cai {
  display: flex;
  align-items: center;
}
.cai-input-box > div {
  display: flex;
  align-items: center;
}
.cai-input-box > div > span {
  width: 50px;
  margin-right: 5px;
}
.form-area {
  margin: 20px 0;
}
.form-row {
  display: flex;
  flex-flow: row nowrap;
  border: 1px solid #dcdfe6;
}
.column-meal-type {
  flex: 2;
  padding: 0 10px;
}
.column-meal-noon {
  flex: 4;
  text-align: center;
  border-left: #dcdfe6 solid 1px;
  border-right: #dcdfe6 solid 1px;
}
.column-meal-supper {
  flex: 4;
  text-align: center;
}
.row-col-center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.set-padding {
  padding: 6px 10px;
}
.post-form-btn {
  margin: 12px 0;
}
.avatar-uploader {
  margin: 0 12px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
